module.exports = __webpack_public_path__ + "img/offers.598a96c3.svg";